import React from "react";

const PATHS = {
  heart:   "M0,3 C-3,0 -6,2 -6,5 C-6,8 -2,12 0,14 C2,12 6,8 6,5 C6,2 3,0 0,3 Z",
  spark:   "M0,-5 L1,-1 L5,0 L1,1 L0,5 L-1,1 L-5,0 L-1,-1 Z",
  arrow:   "M-5,0 L3,0 M0,-3 L3,0 L0,3",
  swirl:   "M0,0 C2,0 2,2 0,2 C-2,2 -2,-1 1,-1 C4,-1 3,3 -1,3",
  wavy:    "M-5,0 C-3,-2 -2,2 0,0 C2,-2 3,2 5,0",
  check:   "M-3,0 L-1,3 L4,-3",
  exclaim: "M0,-5 L0,2 M0,4 L0,5",
};

const DOODLES = [
  { type: "heart",   x: 15, y: 18, rot: -10, stroke: "#F0BE39", sw: 1.1, delay: -1,    dur: 14 },
  { type: "spark",   x: 78, y: 14, rot:  5,  stroke: "#FFFFFF", sw: 0.9, delay: -4,    dur: 12 },
  { type: "arrow",   x: 42, y: 28, rot: -20, stroke: "#3EB567", sw: 0.9, delay: -7,    dur: 10 },
  { type: "swirl",   x: 62, y: 36, rot:  0,  stroke: "#FF7AAC", sw: 0.9, delay: -3,    dur: 13 },
  { type: "spark",   x: 22, y: 48, rot: 15,  stroke: "#FF8F47", sw: 1.0, delay: -6,    dur: 11 },
  { type: "wavy",    x: 52, y: 58, rot:  0,  stroke: "#FFFFFF", sw: 0.9, delay: -2,    dur: 12 },
  { type: "heart",   x: 72, y: 62, rot: 12,  stroke: "#FFFFFF", sw: 1.0, delay: -9,    dur: 15 },
  { type: "arrow",   x: 30, y: 72, rot: 10,  stroke: "#F0BE39", sw: 0.9, delay: -5,    dur: 11 },
  { type: "check",   x: 14, y: 64, rot: -5,  stroke: "#3EB567", sw: 1.0, delay: -8,    dur: 10 },
  { type: "spark",   x: 86, y: 82, rot: -8,  stroke: "#3EB567", sw: 0.9, delay: -3.5,  dur: 13 },
  { type: "heart",   x: 12, y: 88, rot: -5,  stroke: "#FF8F47", sw: 1.0, delay: -11,   dur: 14 },
  { type: "exclaim", x: 48, y: 88, rot:  4,  stroke: "#F0BE39", sw: 1.2, delay: -6.5,  dur: 12 },
  { type: "heart",   x: 60, y: 18, rot:  8,  stroke: "#FF7AAC", sw: 1.0, delay: -2.5,  dur: 13 },
  { type: "spark",   x: 45, y:  8, rot: -12, stroke: "#3EB567", sw: 0.9, delay: -5.5,  dur: 11 },
  { type: "arrow",   x: 88, y: 30, rot:  20, stroke: "#FFFFFF", sw: 0.9, delay: -3.5,  dur: 10 },
  { type: "swirl",   x: 32, y: 42, rot:  15, stroke: "#F0BE39", sw: 0.9, delay: -7.5,  dur: 14 },
  { type: "spark",   x:  8, y: 32, rot: -5,  stroke: "#FF7AAC", sw: 1.0, delay: -2,    dur: 12 },
  { type: "wavy",    x: 88, y: 52, rot:  5,  stroke: "#FF8F47", sw: 0.9, delay: -10,   dur: 13 },
  { type: "heart",   x: 76, y: 28, rot: -8,  stroke: "#3EB567", sw: 1.0, delay: -4.5,  dur: 14 },
  { type: "arrow",   x: 60, y: 78, rot: -15, stroke: "#FF7AAC", sw: 0.9, delay: -8.5,  dur: 11 },
  { type: "check",   x: 38, y: 52, rot:  8,  stroke: "#FF8F47", sw: 1.0, delay: -3,    dur: 10 },
  { type: "spark",   x: 26, y: 28, rot:  18, stroke: "#F0BE39", sw: 0.9, delay: -6,    dur: 12 },
  { type: "heart",   x: 38, y: 66, rot:  15, stroke: "#FF7AAC", sw: 1.1, delay: -9.5,  dur: 15 },
  { type: "exclaim", x:  4, y: 76, rot: -10, stroke: "#FFFFFF", sw: 1.2, delay: -2,    dur: 12 },
];

export const DoodlesBackground = ({ bgColor = "#3E8DFF" }) => (
  <div className="absolute w-full h-full overflow-hidden">
    <svg
      preserveAspectRatio="xMidYMid slice"
      className="w-full h-full"
      viewBox="0 0 100 100"
      style={{ backgroundColor: bgColor }}
    >
      <defs>
        <style>{`
          @keyframes handDraw {
            0%   { stroke-dashoffset: 100; opacity: 0;    }
            4%   { stroke-dashoffset: 100; opacity: 0.95; }
            20%  { stroke-dashoffset: 0;   opacity: 0.95; }
            75%  { stroke-dashoffset: 0;   opacity: 0.95; }
            88%  { stroke-dashoffset: 0;   opacity: 0;    }
            100% { stroke-dashoffset: 100; opacity: 0;    }
          }
          .doodle {
            animation-name: handDraw;
            animation-timing-function: ease-in-out;
            animation-iteration-count: infinite;
            stroke-dasharray: 100;
            stroke-dashoffset: 100;
          }
        `}</style>
      </defs>
      {DOODLES.map((d, i) => (
        <path
          key={i}
          d={PATHS[d.type]}
          pathLength="100"
          transform={`translate(${d.x},${d.y}) rotate(${d.rot})`}
          fill="none"
          stroke={d.stroke}
          strokeWidth={d.sw}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="doodle"
          style={{ animationDelay: `${d.delay}s`, animationDuration: `${d.dur}s` }}
        />
      ))}
    </svg>
  </div>
);
